import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { checkForTotalColumn, defaultTotalRow, tableColumns } from "./data";
import { IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { DisabledBox } from "../data";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
	flex: 1,
};

export const TotalBox = ({ field, row }) => {
	return (
		<Box
			width="100%"
			height="100%"
			display="flex"
			alignItems="center"
			justifyContent="center"
			sx={{ background: grey[200], fontWeight: 600 }}>
			<span>{row[field]}</span>
		</Box>
	);
};

const GarmentTotalTable = ({ rows, setRows, garmentTotal, setGarmentTotal }) => {
	const defTableColumns = [
		{
			...colStyle,
			headerName: "Category",
			field: "category",
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <DisabledBox field={field} row={row} />;
			},
		},
		{
			...colStyle,
			headerName: "Value",
			field: "value",
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <DisabledBox field={field} row={row} />;
			},
		},
	];

	const [tableColumns, setTableColumns] = useState(defTableColumns);
	const [tableRows, setTableRows] = useState([]);

	useEffect(() => {
		const arr = rows;
		let garmentTotal = rows?.reduce((acc, row) => {
			if (!isNaN(row?.value)) acc += row?.value;
			return acc;
		}, 0);
		const total = { ...defaultTotalRow, value: roundDecimalValueUptoTwoDigit(garmentTotal) };
		setGarmentTotal(total);
		setTableRows([total, ...arr]);
	}, [rows]);

	return (
		<Box>
			<Typography variant="h6"> Garment Total</Typography>
			<Box width="100%">
				<DataGrid
					rows={tableRows}
					getRowId={(row) => row.category + row.value}
					columns={tableColumns}
					sx={{
						width: "100%",
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
							textTransform: "uppercase",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					autoHeight
					showCellVerticalBorder
					showColumnVerticalBorder
					density="compact"
					isCellEditable={({ row }) => !checkForTotalColumn(row)}
				/>
			</Box>
		</Box>
	);
};

export default GarmentTotalTable;
